import apiFactory from '../utils/apiFactory';

const getPostalPricing = async (params) => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing`,
      method: 'GET',
   }
   return apiFactory(api, {}, params)
}

const getPostalTypes = async () => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing/types`,
      method: 'GET',
   }
   return apiFactory(api)
}

const getCities = async () => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing/cities`,
      method: 'GET',
   }
   return apiFactory(api)
}

const getPostalPricingById = async (id, params) => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing/${id}`,
      method: 'GET',
   }
   return apiFactory(api, {}, params)
}

const createPostalPricing = async (payload, params) => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing`,
      method: 'POST',
   }
   return apiFactory(api, payload, params)
}

const updatePostalPricing = async (id, payload, params) => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing/${id}`,
      method: 'PUT',
   }
   return apiFactory(api, payload, params)
}

const updatePostalPricingStatus = async (id, payload, params) => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing/${id}/status`,
      method: 'PATCH',
   }
   return apiFactory(api, payload, params)
}

const deletePostalPricing = async (id, params) => {
   let api = {
      content_type: 'application/json',
      url: `postal-pricing/${id}`,
      method: 'DELETE',
   }
   return apiFactory(api, {}, params)
}

export default {
   getPostalPricing,
   getPostalTypes,
   getCities,
   getPostalPricingById,
   createPostalPricing,
   updatePostalPricing,
   updatePostalPricingStatus,
   deletePostalPricing,
}